import React from 'react';
import {View} from 'react-native';
import {Components} from '@oneamerica/dxp-ui-components';
import responsiveStyle from '../PremiumsReceived/style';
import InfoWrapper from '../../../../components/InfoWrapper/InfoWrapper';

const IncomePaymentInformation = ({incomePaymentInformationData}) => {
  const style = responsiveStyle();
  return (
    <View className="lg:flex-row pt-6">
      <View className="w-full p-0 mt-1">
        <View style={style.cardShadow}>
          <View style={style.cardHeader}>
            <Components.Text.H3 style={[style.cardHeaderTitle, style.flex]}>
              Income Payment Information
            </Components.Text.H3>
          </View>
          <View className="mt-4" style={style.horizontalDivider} />
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
            className="mt-4 w-full">
            {incomePaymentInformationData.map((data, index) => {
              return (
                <View
                  key={`${data.title}-${index}`}
                  style={{
                    paddingBottom: 20,
                  }}
                  className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/4">
                  <InfoWrapper
                    title={data.title}
                    subTitle
                    information={data.value || '-'}
                    infoTextStyle={{
                      fontWeight: '500',
                    }}
                  />
                </View>
              );
            })}
          </View>
        </View>
      </View>
    </View>
  );
};

export default IncomePaymentInformation;
